"use client";

import React, { createContext, ReactNode, useState } from "react";

import {
  ClubContextValue,
  ClubFormatProps,
} from "@/TS/Interfaces/global_interfaces";

export const ClubContext = createContext<ClubContextValue>(undefined!);

function ClubProvider({ children }: { children: ReactNode }) {
  const [format, setFormat] = useState<Partial<ClubFormatProps> | undefined>(
    undefined,
  );

  return (
    <ClubContext.Provider value={{ format, setFormat }}>
      {children}
    </ClubContext.Provider>
  );
}

export default ClubProvider;
